const KEY = 'USER_GROUP';
// [KEY] 하위로 둬야 구성원 변경 후 [KEY] 무효화 한 번에 목록·회원 수까지 걸린다.
const MEMBER_KEY = 'MEMBER';

export { KEY, MEMBER_KEY };
